/**
 * DPT Set to Compose — disable checkout when bundle stock issues are flagged in cart markup.
 */
(function () {
  function syncCheckoutButtons() {
    var hasIssue = !!document.querySelector('[data-stc-bundle-stock-issue]');
    document.querySelectorAll('.checkout-button').forEach(function (btn) {
      btn.disabled = hasIssue;
      btn.classList.toggle('disabled', hasIssue);
      btn.setAttribute('aria-disabled', hasIssue ? 'true' : 'false');
    });
  }

  function init() {
    syncCheckoutButtons();
    document.addEventListener('cart:refresh', syncCheckoutButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.dptStcCartSyncCheckout = syncCheckoutButtons;
})();
